export const pageNames = Object.freeze({
  // <---- Channel Steering Page Group ---->
  contactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-us:::',
    e: 'im',
    event_name: 'classic_help_contactus_page_shown',
  },
  contactUsPageContactOptions: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-options:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_contact_option_shown',
  },
  contactUsPageUpfrontFAQ: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::upfront-faq:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_upfront_faq_shown',
  },
  contactUsPageSearchBox: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intent-search:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_intent_search',
  },
  contactUsChatTimeoutPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chat-timeout:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::callus:::',
    e: 'im',
    event_name: 'classic_help_callus_page_shown',
  },
  // Call Us redesign page
  callPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::call:::',
    e: 'im',
    event_name: 'classic_help_callus_page_shown',
  },
  callPageInvalidTopicCode: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::call-invalid-topic-code:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::email:::',
    e: 'im',
    event_name: 'classic_help_email_page_shown',
  },
  emailByPassPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass:::',
  },
  complaintsWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::complaints:::',
    e: 'im',
    event_name: 'classic_help_complaints_webform_page_shown',
  },
  complaintsDropdownChange: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::complaints:::',
    e: 'ac',
    event_name: 'classic_help_complaints_webform_dropwown_changed',
  },
  complaintsSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::complaints:::',
    e: 'cl',
    event_name: 'classic_help_complaints_submit_button_clicked',
  },
  privacyWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'im',
    event_name: 'classic_help_privacy_webform_page_shown',
  },
  privacyWebformLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy-error:::',
    e: 'im',
    event_name: 'classic_help_privacy_webform_page_load_error',
  },
  privacyWebformContentClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_link_clicked',
  },
  privacyWebformMesssageUsClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_message_us_icon_clicked',
  },
  privacyWebformLoginClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_login_clicked',
  },
  privacyWebformNoAccountLoginClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_no_account_login_link_clicked',
  },

  aupviolationWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'im',
    event_name: 'classic_help_aupviolation_webform_page_shown',
  },
  aupviolationVenmoImage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_page_venmo_image_exists',
  },
  aupviolationWebformLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation-error:::',
    e: 'im',
    event_name: 'classic_help_aupviolation_webform_page_load_error',
  },
  aupviolationWebformLoginClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_login_clicked',
  },
  aupviolationWebformReportClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_report_button_clicked',
  },
  aupviolationWebformContentClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_link_clicked',
  },
  payuponinvoiceWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'im',
    event_name: 'classic_help_payuponinvoice_webform_page_shown',
  },
  payuponinvoiceWebformLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice-error:::',
    e: 'im',
    event_name: 'classic_help_payuponinvoice_webform_page_load_error',
  },
  payuponinvoiceWebformContactUsClick: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_page_contact_us_link_clicked',
  },
  payuponinvoiceWebformLogin: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_page_login_clicked',
  },
  ipinfringementWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'im',
    event_name: 'classic_help_ipinfringement_webform_page_shown',
  },
  ipinfringementWebformLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement-error:::',
    e: 'im',
    event_name: 'classic_help_ipinfringement_webform_page_load_error',
  },
  // email form submit
  privacyWebformEmailFormSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_page_email_form_submit',
  },
  payuponinvoiceWebformEmailFormSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_page_email_form_submit',
  },
  ppgfWebformEmailFormSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'ac',
    event_name: 'classic_help_ppgf_webform_page_email_form_submit',
  },
  aupviolationWebformEmailFormSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_page_email_form_submit',
  },
  ipinfringementWebformEmailFormSubmit: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'ac',
    event_name: 'classic_help_ipinfringement_webform_page_email_form_submit',
  },

  // email submit success
  privacyEmailSubmitSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'im',
    event_name: 'classic_help_privacy_webform_email_submit_success',
  },
  aupviolationEmailSubmitSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'im',
    event_name: 'classic_help_aupviolation_webform_email_submit_success',
  },
  payuponinvoiceEmailSubmitSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'im',
    event_name: 'classic_help_payuponinvoice_webform_email_submit_success',
  },
  ppgfEmailSubmitSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'im',
    event_name: 'classic_help_ppgf_webform_email_submit_success',
  },
  ipinfringementEmailSubmitSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'im',
    event_name: 'classic_help_ipinfringement_webform_email_submit_success',
  },

  // email submit failure
  privacyEmailSubmitFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'im',
    event_name: 'classic_help_privacy_webform_email_submit_failed',
  },
  aupviolationEmailSubmitFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'im',
    event_name: 'classic_help_aupviolation_webform_email_submit_failed',
  },
  payuponinvoiceEmailSubmitFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'im',
    event_name: 'classic_help_payuponinvoice_webform_email_submit_failed',
  },
  ppgfEmailSubmitFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'im',
    event_name: 'classic_help_ppgf_webform_email_submit_failed',
  },
  ipinfringementEmailSubmitFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'im',
    event_name: 'classic_help_ipinfringement_webform_email_submit_failed',
  },

  // content link click in Notes component
  privacyContentLink: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'cl',
    event_name: 'classic_help_privacy_webform_content_link_clicked',
  },
  aupviolationContentLink: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'cl',
    event_name: 'classic_help_aupviolation_webform_content_link_clicked',
  },
  payuponinvoiceContentLink: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'cl',
    event_name: 'classic_help_payuponinvoice_webform_content_link_clicked',
  },
  ppgfContentLink: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'cl',
    event_name: 'classic_help_ppgf_webform_content_link_clicked',
  },
  privacyLinkTryAgainClick: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy-emailNoIntentError:::',
    e: 'cl',
    event_name: 'classic_help_privacy_email_no_intent_try_again_on_error_clicked',
  },
  ppgfLinkTryAgainClick: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf-emailNoIntentError:::',
    e: 'cl',
    event_name: 'classic_help_ppgf_email_no_intent_try_again_on_error_clicked',
  },
  payuponinvoiceLinkTryAgainClick: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice-emailNoIntentError:::',
    e: 'cl',
    event_name: 'classic_help_payuponinvoice_email_no_intent_try_again_on_error_clicked',
  },
  // webform topic tree data error
  privacyTopicTreeDataError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'im',
    event_name: 'classic_help_privacy_webform_topic_tree_data_error',
  },
  aupviolationTopicTreeDataError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'im',
    event_name: 'classic_help_aupviolation_webform_topic_tree_data_error',
  },
  payuponinvoiceTopicTreeDataError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'im',
    event_name: 'classic_help_payuponinvoice_webform_topic_tree_data_error',
  },
  ppgfTopicTreeDataError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'im',
    event_name: 'classic_help_ppgf_webform_topic_tree_data_error',
  },
  ipinfringementTopicTreeDataError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'im',
    event_name: 'classic_help_ipinfringement_webform_topic_tree_data_error',
  },

  // Quick answers successfully loaded
  privacyQuickAnswersSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_page_quick_answers_shown',
  },
  payuponinvoiceQuickAnswersSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_page_quick_answers_shown',
  },
  ppgfQuickAnswersSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'ac',
    event_name: 'classic_help_ppgf_webform_page_quick_answers_shown',
  },
  aupviolationQuickAnswersSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_page_quick_answers_shown',
  },
  ipinfringementQuickAnswersSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'ac',
    event_name: 'classic_help_ipinfringement_webform_page_quick_answers_shown',
  },
  privacyErrorMessageShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy-emailNoIntentError:::',
    e: 'ac',
    event_name: 'classic_help_privacy_email_no_intent_error_message_shown',
  },
  ppgfErrorMessageShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf-emailNoIntentError:::',
    e: 'ac',
    event_name: 'classic_help_ppgf_email_no_intent_error_message_shown',
  },
  payuponinvoiceErrorMessageShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice-emailNoIntentError:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_email_no_intent_error_message_shown',
  },
  // Quick answers Failed to load
  privacyQuickAnswersFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::privacy:::',
    e: 'ac',
    event_name: 'classic_help_privacy_webform_page_quick_answers_failed',
  },
  payuponinvoiceQuickAnswersFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_page_quick_answers_failed',
  },
  ppgfQuickAnswersFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'ac',
    event_name: 'classic_help_ppgf_webform_page_quick_answers_failed',
  },
  aupviolationQuickAnswersFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::aupviolation:::',
    e: 'ac',
    event_name: 'classic_help_aupviolation_webform_page_quick_answers_failed',
  },
  ipinfringementQuickAnswersFailed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ipinfringement:::',
    e: 'ac',
    event_name: 'classic_help_ipinfringement_webform_page_quick_answers_failed',
  },
  // message us click
  payuponinvoiceWebformMesssageUsClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::payuponinvoice:::',
    e: 'ac',
    event_name: 'classic_help_payuponinvoice_webform_message_us_clicked',
  },

  ppgfWebformShown: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf:::',
    e: 'im',
    event_name: 'classic_help_ppgf_webform_page_shown',
  },
  ppgfWebformLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::ppgf-error:::',
    e: 'im',
    event_name: 'classic_help_ppgf_webform_page_load_error',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_shown',
  },
  intermediatePageClose: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate:::',
    e: 'cl',
    link: 'smarthelp-intermediate|close',
    event_name: 'classic_help_intermediate_page_close',
  },
  chatBot: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_contactus_page_shown',
  },
  chatBotContactUsIneligible: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_ineligible_in_contactus_page_shown',
  },
  webPinNotApplicable: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-not-applicable:::',
    e: 'ac',
    event_name: 'classic_help_callus_page_webpin_not_applicable',
  },
  chatMessageUsChatBotLoadError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chat-empty-channel:::',
  },

  // webPin Impression tracking
  webPinSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin:::',
    e: 'ac',
    event_name: 'classic_help_callus_page_webpin_shown',
  },

  webPinfailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-error:::',
    e: 'ac',
    event_name: 'classic_help_callus_page_webpin_not_shown',
  },

  // <---- Error Pages ---->
  ErrorPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::error:::',
  },
  emailByPassPageError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass-error:::',
  },
  chatBotArticleInEligible: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::smart-chatBotInEligible:::',
  },
  chatBotArticleError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
    e: 'ac',
    event_name: 'classic_help_chat_bot_loading_error_in_article_page',
  },
  chatBotContactUsError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
    e: 'ac',
    event_name: 'classic_help_chat_bot_loading_error_in_contact_page',
  },
  chatBotHomeError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
    e: 'ac',
    event_name: 'classic_help_chat_bot_loading_error_in_home_page',
  },
  contactLexaFailureError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },
  articleLexaFailureError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },
  asyncContactUsError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::async-chat-did-not-load-error:::',
    e: 'ac',
    event_name: 'classic_help_async_chat_not_loaded_in_contactus_page',
  },
  loggedOutChatCaptchaSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate-captcha:::',
    e: 'ac',
    event_name: 'classic_help_logged_out_chat_captcha_success',
  },
  loggedOutChatCaptchaError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate-captcha:::',
    e: 'ac',
    event_name: 'classic_help_logged_out_chat_captcha_error',
  },

  // <---- HCR Page Group ---->
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
    e: 'im',
    event_name: 'classic_help_home_page_shown',
  },
  PCCTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pcc:::',
    e: 'ac',
    event_name: 'classic_help_pcc_article_in_home_page_shown',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search:::',
    e: 'im',
    event_name: 'classic_help_search_page_shown',
  },
  fullSearchClickedInhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_home_page',
  },
  fullSearchClickedInarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_article_page',
  },
  fullSearchClickedInsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_search_page',
  },
  fullSearchClickedIntopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_topic_page',
  },
  fullSearchClickedInICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topics',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_icf_topics_page',
  },
  fullSearchClickedInICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::full-search-clicked:::',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_icf_article_page',
  },
  searchBarFocusedInhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_home_page',
  },
  searchBarFocusedInarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_article_page',
  },
  searchBarFocusedInsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_search_page',
  },
  searchBarFocusedIntopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_topic_page',
  },
  searchBarFocusedInICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topics',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_icf_topics_page',
  },
  searchBarFocusedInICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_icf_article_page',
  },
  quicklinksShownInhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_home_page',
  },
  quicklinksShownInarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_article_page',
  },
  quicklinksShownInsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_search_page',
  },
  quicklinksShownIntopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_topic_page',
  },
  quicklinksShownInICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topics',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_icf_topics_page',
  },
  quicklinksShownInICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_icf_article_page',
  },
  searchErrorPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-error:::',
    e: 'im',
    event_name: 'classic_help_search_error_page_shown',
  },
  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
    e: 'im',
    event_name: 'classic_help_article_page_shown',
  },
  articleErrorPage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-error:::',
    e: 'im',
    event_name: 'classic_help_article_error_page_shown',
  },
  currencyConverterArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::currency-converter:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'im',
    event_name: 'classic_help_topic_page_shown',
  },
  L3topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'im',
    event_name: 'classic_help_level3_topic_page_shown',
  },
  L3topicErrorPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic-error:::',
    e: 'im',
    event_name: 'classic_help_level3_topic_error_page_shown',
  },
  L1topicClicked: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
    e: 'cl',
    event_name: 'classic_help_level1_topic_clicked',
  },
  L2topicClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_level2_topic_clicked',
  },
  L3topicClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_level3_topic_clicked',
  },
  L2TopicAccordionClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_level2_topic_accordion_clicked',
  },
  L3TopicAccordionClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_level3_topic_accordion_clicked',
  },
  L2topicArticleClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_article_clicked_under_level2_topic',
  },
  L3topicArticleClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_article_clicked_under_level3_topic',
  },
  sideBarArticleClicked: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
    e: 'cl',
    event_name: 'classic_help_article_clicked_on_sidebar_in_article_page',
  },
  L2topicArticleShowMoreClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_topic_level2_show_more_clicked',
  },
  L3topicArticleShowMoreClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
    e: 'cl',
    event_name: 'classic_help_topic_level3_article_show_more_clicked',
  },
  chatBotHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_home_page_shown',
  },
  chatBotArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot:::',
    e: 'ac',
    event_name: 'classic_help_chatbot_in_article_page_shown',
  },
  topicErrorPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic-error:::',
    e: 'im',
    event_name: 'classic_help_topic_error_page_shown',
  },
  articleintermediatePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_in_article_page_shown',
  },
  CC3TrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::cc3:::',
  },
  omniTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni:::',
  },
  // <!-- Step-up -->
  stepUpIntermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_stepUpFlow_shown',
  },
  stepUpIntermediatePage_anwFailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-anwFailure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_anw_failure',
  },
  stepUpIntermediatePage_anwIgnoreDecisions: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-IgnoreDecisions:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_ignoreDecisions',
  },
  stepUpIntermediatePage_decision: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-decisions:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_decision',
  },
  stepUpIntermediatePage_no_translations: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-no-translations:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_no_translations',
  },
  stepUpIntermediatePage_riskFailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-risk-failure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_risk_failure',
  },
  stepUpIntermediatePage_anw_service_failure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate-anw-service-failure:::',
    e: 'ac',
    event_name: 'classic_help_intermediate_page_stepup_anw_service_failure',
  },
  confirmAuthPrompt: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-prompt:::',
    e: 'ac',
    event_name: 'classic_help_stepup_auth_confirmation_modal_window_shown',
  },
  confirmAuthPromptOnClick: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-prompt:::',
    e: 'cl',
  },
  confirmAuthFailure: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-failure:::',
    e: 'ac',
    event_name: 'classic_help_stepup_auth_confirmation_modal_window_failure',
  },

  // Dispute-Info
  disputeContactInfo: {
    // Dispute alert default tracking
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::dispute-status-info:::',
    e: 'ac',
    event_name: 'classic_help_dispute_alert_in_contactus_page_shown',
  },

  disputeSearchInfo: {
    // Dispute alert default tracking
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::dispute-status-info:::',
    e: 'ac',
    event_name: 'classic_help_dispute_alert_in_search_page_shown',
  },

  disputeTransactions: {
    pageGroupName: 'main:help:smart::transactions',
    pageName: 'main:help:smart::dispute-transactions:::',
    e: 'ac',
    event_name: 'classic_help_dispute_transactions_in_article_page_shown',
  },

  // ICF-Info

  ICFGuide: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::icf-guide:::',
    e: 'ac',
    event_name: 'classic_help_icf_guide_in_home_page_shown',
  },

  ICFL1Topic: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::icf:::',
    e: 'ac',
    event_name: 'classic_help_icf_guides_entry_in_L1_topic_in_home_page_shown',
  },

  ICFPage: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::icf-articles:::',
    e: 'im',
    event_name: 'classic_help_icf_article_page_shown',
  },

  ICFPageError: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::icf-articles-error:::',
    e: 'im',
    event_name: 'classic_help_icf_article_error_page_shown',
  },

  ICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::icf-topic:::',
    e: 'im',
    event_name: 'classic_help_icf_topic_page_shown',
  },

  ICFTopicPageError: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::icf-topic-error:::',
    e: 'im',
    event_name: 'classic_help_icf_topic_error_page_shown',
  },

  // NAA Alert
  NAAContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_contactus_page_shown',
  },
  NAAHomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_home_page_shown',
  },
  NAAArticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_article_page_shown',
  },
  NAASearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_search_page_shown',
  },
  NAATopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_topic_page_shown',
  },
  NAAIcfPage: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::naa-alert:::',
    e: 'ac',
    event_name: 'classic_help_naa_alert_in_icftopic_page_shown',
  },

  // COVID BCP SUPPRESS CALLUS ALERT WINDOW
  covidBcpCallUsAlert: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::covid-bcp-callus-alert-window:::',
  },

  // Covid popup alerts
  contactUsAlertPopup: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_contactus_page_shown',
  },
  homeAlertPopup: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_home_page_shown',
  },
  searchAlertPopup: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_search_page_shown',
  },
  articleAlertPopup: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_article_page_shown',
  },
  topicAlertPopup: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_topic_page_shown',
  },
  ICFTopicAlertPopup: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_icftopic_page_shown',
  },
  ICFPageAlertPopup: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::pop-up-alert:::',
    e: 'ac',
    event_name: 'classic_help_popup_alert_in_icfalert_page_shown',
  },

  // Covid popup alerts
  // FPTI for critical alerts
  contactUsCriticalAlert: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_contact_page_shown',
  },
  contactUsCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_contact_us_page',
  },
  homeCriticalAlert: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_home_page_shown',
  },
  homeCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_home_page',
  },
  searchCriticalAlert: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_search_page_shown',
  },
  searchCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_search_page',
  },
  articleCriticalAlert: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_article_page_shown',
  },
  articleCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_article_page',
  },
  topicCriticalAlert: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_topic_page_shown',
  },
  topicCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_topic_page',
  },
  ICFTopicCriticalAlert: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_icftopic_page_shown',
  },
  ICFTopicCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_icf_topic_page',
  },
  ICFPageCriticalAlert: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'ac',
    event_name: 'classic_help_critical_alert_in_icfarticle_page_shown',
  },
  ICFPageCriticalAlertContentClicked: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::critical-alert:::',
    e: 'cl',
    event_name: 'classic_help_critical_alert_content_link_clicked_in_icf_page',
  },

  // FPTI for warning alert
  homeWarningAlert: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::warning-alert:::',
    e: 'ac',
    event_name: 'classic_help_warning_alert_in_home_page_shown',
  },
  homeWarningAlertContentClicked: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::warning-alert:::',
    e: 'cl',
    event_name: 'classic_help_warning_alert_content_link_clicked_in_home_page',
  },

  // FPTI for info alert
  homeInfoAlert: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::info-alert:::',
    e: 'ac',
    event_name: 'classic_help_info_alert_in_home_page_shown',
  },
  homeInfoAlertContentClicked: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::info-alert:::',
    e: 'cl',
    event_name: 'classic_help_info_alert_content_link_clicked_in_home_page',
  },

  // Refund Tracker
  refundsTrackerContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_contactus_page_shown',
  },
  refundsTrackerHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_home_page_shown',
  },
  refundsTrackerArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::refund-status-tracker:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_tracker_in_article_page_shown',
  },
  refundAlertContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::refund-status-alert:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_alert_in_contactus_page_shown',
  },
  refundAlertSearch: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::refund-status-alert:::',
    e: 'ac',
    event_name: 'classic_help_refund_status_alert_in_search_page_shown',
  },
  // NNA
  nnaHomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::nna-widget:::',
    e: 'ac',
    event_name: 'classic_help_nna_widget_in_home_page_shown',
  },
  nnaHomePageError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::nna-widget-error:::',
    e: 'ac',
    event_name: 'classic_help_nna_widget_error_in_home_page',
  },
  // omniChannel
  updateContexthomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context:::',
  },
  updateContextSuccesshomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_success',
  },
  updateContextFailurehomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed',
  },
  updateContextcontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::update-context:::',
  },
  updateContextSuccesscontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::update-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_success',
  },
  updateContextFailurecontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::update-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed',
  },

  updateContextStepUp: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-update-context:::',
  },
  updateContextSuccessStepUp: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-update-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_step_up_update_context_success',
  },
  updateContextFailureStepUp: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-update-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_step_up_update_context_failed',
  },

  setContexthomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_home_ocp_set_context_fired',
  },
  setContextSuccesshomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailurehomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  setContextcontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_contactus_ocp_set_context',
  },
  setContextSuccesscontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_contactus_ocp_set_context_success',
  },
  setContextFailurecontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_contactus_ocp_set_context_failed',
  },

  setContextarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_article_ocp_set_context_fired',
  },
  setContextSuccessarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailurearticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  setContexttopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_topic_ocp_set_context_fired',
  },
  setContextSuccesstopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailuretopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  setContextICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_icf_ocp_set_context_fired',
  },
  setContextSuccessICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailureICFTopic: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  setContextsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::set-context:::',
    e: 'ac',
    event_name: 'classic_help_search_ocp_set_context_fired',
  },
  setContextSuccesssearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::set-context-success:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailuresearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::set-context-failed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  omniChannelSetContextNotFiredhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-set-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_not_fired',
  },
  omniChannelSetContextNotFiredcontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-set-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_contactus_ocp_set_context_not_fired',
  },
  omniChannelSetContextNotFiredarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::omni-channel-set-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_not_fired',
  },
  omniChannelSetContextNotFiredsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::omni-channel-set-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_not_fired',
  },
  omniChannelSetContextNotFiredIcfPage: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::omni-channel-set-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_not_fired',
  },

  // Brexit
  complaintsPage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'ac',
    event_name: 'classic_help_complaints_page_displayed',
  },
  complaintsPageModal: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page-modal:::',
    e: 'ac',
    event_name: 'classic_help_complaints_page_modal_displayed',
  },
  complaintsDataPanel: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'ac',
    event_name: 'classic_help_complaints_data_shown',
  },
  complaintsDataSheetOpen: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'cl',
    event_name: 'classic_help_complaints_data_sheet_open',
  },
  complaintsDataSheetClose: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'cl',
    event_name: 'classic_help_complaints_data_sheet_close',
  },

  complaintsPageLoad: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::complaints-page:::',
    e: 'im',
    event_name: 'classic_help_complaints_page_displayed',
  },

  complaintsIntermediatePage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::intermediate:::',
    e: 'im',
    event_name: 'classic_help_intermediate_page_in_complaints_page_displayed',
  },
  searchBarFocusedIncomplaintsPage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::search-bar-focused:::',
    e: 'cl',
    event_name: 'classic_help_search_bar_focused_in_complaints_page',
  },
  quicklinksShownIncomplaintsPage: {
    pageGroupName: 'main:help:smart::complaints',
    pageName: 'main:help:smart::quicklinks-shown:::',
    e: 'ac',
    event_name: 'classic_help_quicklinks_for_common_questions_shown_in_complaints_page',
  },
  fullSearchClickedIncomplaintsPage: {
    pageGroupName: 'main:help:smart:complaints',
    pageName: 'main:help:smart:full-search-clicked',
    e: 'cl',
    event_name: 'classic_help_full_search_clicked_in_complaints_page',
  },
  omniChannelPromptDisplayed: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-prompt-displayed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_prompt_displayed',
  },

  omniChannelPromptNotDisplayed: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-prompt-not-displayed:::',
    e: 'ac',
    event_name: 'classic_help_ocp_prompt_not_displayed',
  },
  omniChannelUpdateContextNotFiredHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::omni-channel-update-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_not_fired',
  },
  omniChannelUpdateContextNotFiredContactUs: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-update-context-not-fired:::',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_not_fired',
  },

  contactUsOmniChannelPromptDisplayed: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-prompt:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_ocp_prompt_displayed',
  },
  contactUsOmniChannelPromptClicked: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-prompt:::',
  },
  contactUsOmniChannelPromptFinalIntentRedirectError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-prompt-error:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_ocp_prompt_final_intent_redirect_error',
  },
  contactUsOmniChannelPromptError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::omni-channel-prompt-error:::',
    e: 'ac',
    event_name: 'classic_help_contactus_page_ocp_prompt_not_displayed_due_to_render_error',
  },
  enhancedFooterFeedbackClickError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::enhanced-footer-feedback-error:::',
  },

  // Qualtrics survey component
  qualtricsFeedbackcontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_contact_page_shown',
  },
  qualtricsFeedbackhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_home_page_shown',
  },
  qualtricsFeedbacksearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_search_page_shown',
  },
  qualtricsFeedbackarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_article_page_shown',
  },
  qualtricsFeedbacktopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_topic_page_shown',
  },
  qualtricsFeedbackICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::qualtrics-footer-survey:::',
    e: 'ac',
    event_name: 'classic_help_qualtrics_survey_in_icftopic_page_shown',
  },
  vhtWidgetContactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::schedule-callback-vht-widget:::',
  },
  vhtWidgetSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::schedule-callback-vht-widget:::',
    e: 'im',
    event_name: 'classic_help_schedule_callback_widget_shown_in_contactus_page',
  },
  vhtWidgetError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::schedule-callback-vht-widget-error:::',
    e: 'ac',
    event_name: 'classic_help_schedule_callback_widget_error_in_contactus_page',
  },
  articlePageVideo: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-video:::',
    e: 'ac',
    event_name: 'classic_help_video_displayed_in_article_page',
  },
  icfArticlePageVideo: {
    pageGroupName: 'main:help:smart::icf',
    pageName: 'main:help:smart::icf-article-video:::',
    e: 'ac',
    event_name: 'classic_help_video_displayed_in_icf_article_page',
  },
  machineTranslationArticleButtonShown: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-machine-translation-button-shown:::',
    e: 'ac',
    event_name: 'classic_help_article_machine_translation_button_shown',
  },
  machineTranslationArticleSuccessShown: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-machine-translation-success:::',
    e: 'ac',
    event_name: 'classic_help_article_machine_translation_success_shown',
  },
  machineTranslationArticleErrorShown: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-machine-translation-error:::',
    e: 'ac',
    event_name: 'classic_help_article_machine_translation_error_shown',
  },
  searchCharLimiterTriggeredhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::search-charLimit-error:::',
    e: 'ac',
    event_name: 'classic_help_search_char_limit_error',
  },
  searchCharLimiterTriggeredarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::search-charLimit-error:::',
    e: 'ac',
    event_name: 'classic_help_search_char_limit_error',
  },
  searchCharLimiterTriggeredsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-charLimit-error:::',
    e: 'ac',
    event_name: 'classic_help_search_char_limit_error',
  },
  searchCharLimiterTriggeredtopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::search-charLimit-error:::',
    e: 'ac',
    event_name: 'classic_help_search_char_limit_error',
  },
  searchCharLimiterTriggeredICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::search-charLimit-error:::',
    e: 'ac',
    event_name: 'classic_help_search_char_limit_error',
  },
  // search auto complete error fpti's
  searchAutoCompleteEmptyResulthomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::search-auto-complete-no-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_no_results',
  },
  searchAutoCompleteErrorhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::search-auto-complete-error-response:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_error_response',
  },
  searchAutoCompleteResultsShownhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::search-auto-complete-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_results_shown',
  },
  searchAutoCompleteEmptyResultarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::search-auto-complete-no-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_no_results',
  },
  searchAutoCompleteErrorarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::search-auto-complete-error-response:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_error_response',
  },
  searchAutoCompleteResultsShownarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::search-auto-complete-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_results_shown',
  },
  searchAutoCompleteEmptyResulttopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::search-auto-complete-no-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_no_results',
  },
  searchAutoCompleteErrortopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::search-auto-complete-error-response:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_error_response',
  },
  searchAutoCompleteResultsShowntopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::search-auto-complete-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_results_shown',
  },
  searchAutoCompleteEmptyResultICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::search-auto-complete-no-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_no_results',
  },
  searchAutoCompleteErrorICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::search-auto-complete-error-response:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_error_response',
  },
  searchAutoCompleteResultsShownICFTopic: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::search-auto-complete-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_results_shown',
  },
  searchAutoCompleteEmptyResultsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-auto-complete-no-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_no_results',
  },
  searchAutoCompleteErrorsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-auto-complete-error-response:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_error_response',
  },

  searchAutoCompleteResultsShownsearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-auto-complete-results:::',
    e: 'ac',
    event_name: 'classic_help_search_autocomplete_results_shown',
  },
  emailFormLoadFailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass-error:::',
    e: 'im',
    event_name: 'classic_help_email_form_load_error',
  },
  customChatBotShownarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::custom-chatBot:::',
    e: 'ac',
    event_name: 'classic_help_article_custom_chatbot_shown',
  },
  customChatBotClickedarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::custom-chatBot:::',
    e: 'cl',
    event_name: 'classic_help_article_custom_chatbot_clicked',
  },
  customChatBotShownhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::custom-chatBot:::',
    e: 'ac',
    event_name: 'classic_help_home_custom_chatbot_shown',
  },
  customChatBotClickedhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::custom-chatBot:::',
    e: 'cl',
    event_name: 'classic_help_home_custom_chatbot_clicked',
  },
  updateBNA: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-bna',
    e: 'ac',
    event_name: 'classic_help_update_bna_response_sent',
  },
  updateBNAError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::update-bna',
    e: 'ac',
    event_name: 'classic_help_update_bna_response_not_sent',
  },

  // Customer Journey add new home page fpti as well
  customerJourneycontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_contactus_customer_journey_api',
  },
  customerJourneySuccesscontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_contactus_customer_journey_api_success',
  },
  customerJourneyFailurecontactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_contactus_customer_journey_api_failed',
  },
  customerJourneyhomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_home_customer_journey_api_fired',
  },
  customerJourneySuccesshomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_home_customer_journey_api_success',
  },
  customerJourneyFailurehomePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_home_customer_journey_api_failed',
  },
  customerJourneyarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_article_customer_journey_api_fired',
  },
  customerJourneySuccessarticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_article_customer_journey_api_success',
  },
  customerJourneyFailurearticlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_article_customer_journey_api_failed',
  },
  customerJourneytopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_topic_customer_journey_api_fired',
  },
  customerJourneySuccesstopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_topic_customer_journey_api_success',
  },
  customerJourneyFailuretopicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_topic_customer_journey_api_failed',
  },
  customerJourneyICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_icf_topic_customer_journey_api_fired',
  },
  customerJourneySuccessICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_icf_topic_customer_journey_api_success',
  },
  customerJourneyFailureICFTopicPage: {
    pageGroupName: 'main:help:smart::icf-topic',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_icf_topic_customer_journey_api_failed',
  },
  customerJourneyICFTopic: {
    pageGroupName: 'main:help:smart::icf-articles',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_icf_articles_customer_journey_api_fired',
  },
  customerJourneySuccessICFTopic: {
    pageGroupName: 'main:help:smart::icf-articles',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_icf_articles_customer_journey_api_success',
  },
  customerJourneyFailureICFTopic: {
    pageGroupName: 'main:help:smart::icf-articles',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_icf_articles_customer_journey_api_failed',
  },
  customerJourneysearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::customer-journey:::',
    e: 'ac',
    event_name: 'classic_help_search_customer_journey_api_fired',
  },
  customerJourneySuccesssearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::customer-journey-success:::',
    e: 'ac',
    event_name: 'classic_help_search_customer_journey_api_success',
  },
  customerJourneyFailuresearchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::customer-journey-failed:::',
    e: 'ac',
    event_name: 'classic_help_search_customer_journey_api_failed',
  },
  articleRedirect: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-redirect:::',
    e: 'ac',
    event_name: 'classic_help_article_redirect_to_home',
  },
});

export const PageMapping = {
  'contact-us': 'contactUsPage',
  callus: 'callUsPage',
  email: 'emailPage',
  home: 'homePage',
  search: 'searchPage',
  article: 'articlePage',
  topic: 'topicPage',
  icf: 'ICFTopic',
  PAYPAL_HELP_GUIDE: 'ICFTopic',
  complaints: 'complaintsPage',
};
